import {useParams} from "react-router-dom";

export const Redirect: React.FC = () => {
  const {qrCode} = useParams();
  console.log(qrCode);
  window.location.href = `${
    import.meta.env.VITE_SUPABASE_URL
  }/functions/v1/verify-scan/${qrCode}`;
  return null;
};
